import React from 'react';

import cn from 'classnames';
import { isEmpty } from 'lodash';
import { MdDoneAll } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';

import type { HistoryItemType } from '@appTypes';
import type { RecordedItem } from '@modules/advancement/pendingItems/types';
import { determineAuditData } from '@modules/advancement/pendingItems/utils';
import {
  ActivityTypeIcon,
  AdvancementImage,
  S,
  Tooltip,
} from '@shared/components';
import { advancementStatuses, historyItemsTypes } from '@shared/constants';
import { intl } from '@shared/localization';

import styles from './PendingItemAdvancementName.less';

interface ComponentProps {
  type: HistoryItemType;
  showIcon?: boolean;
  item: RecordedItem & { activityName?: string; isJTE?: boolean };
}

function PendingItemAdvancementName(props: Readonly<ComponentProps>) {
  const { item, type, showIcon = false } = props;
  const auditData = determineAuditData(item);

  switch (type) {
    case historyItemsTypes.ADVANCEMENT: {
      return (
        <div className={styles.advancementContainer}>
          {showIcon && (
            <AdvancementImage src={item.imgUrl} className={styles.image} />
          )}
          <div>
            {item.advancementName}
            {!isEmpty(auditData) && (
              <S size="6" className={styles.audit} italic>
                <FormattedMessage
                  id={`advancement.PendingItems.audit${
                    auditData.name ? '' : 'NoName'
                  }`}
                  values={{
                    status: auditData.status,
                    name: auditData.name,
                    date: auditData.date,
                  }}
                />
              </S>
            )}
          </div>
          {item.status === advancementStatuses.COUNSELOR_APPROVED && (
            <Tooltip
              title={intl.formatMessage({
                id: 'shared.AdvancementStatus.counselorApproved',
              })}
            >
              <MdDoneAll
                className={cn(styles.icon, styles.approved, styles.endAligned)}
              />
            </Tooltip>
          )}
        </div>
      );
    }
    case historyItemsTypes.ACTIVITY: {
      return (
        <span>
          {showIcon && (
            <ActivityTypeIcon
              isJTE={!!item.isJTE}
              activityTypeId={item.activityTypeId}
              className={styles.image}
            />
          )}
          {item.activityName}
        </span>
      );
    }

    default: {
      return null;
    }
  }
}

export default PendingItemAdvancementName;
